import React from 'react';
import styled from '@emotion/styled';

import AnimatedLoader from 'components/BelowTheFoldControl/AnimatedLoader';


const Wrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  z-index: 6;
  background: rgba(0, 0, 0, 0.1);
  transition: width .1s ease-out;
  height: 100vh;
  overflow-y: hidden;

  &.open {
    width: 100vw;
  }
`;

const Container = styled.div`
  height: 100vh;
  width: 85%;
  max-width: 350px;
  overflow-y: auto;
  background: #fff;
  .top {
    padding: 0 8px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
`;

interface LoaderProps {
  height: number;
}

const Loader = styled(AnimatedLoader)`
  height: ${({ height }: LoaderProps) => height}px;
  width: 100%;
  margin: 2px;
`;

function Loading() {
  return (
    <Wrapper>
      <Container>
        <div className="top">
          <Loader className="client" height={55} />
          <Loader className="client" height={55} />
        </div>
        <Loader className="client" height={45} />
        <Loader className="client" height={45} />
        <Loader className="client" height={45} />
        <Loader className="client" height={45} />
        <Loader className="client" height={45} />
        <Loader className="client" height={45} />
        <Loader className="client" height={45} />
        <Loader className="client" height={45} />
        <Loader className="client" height={45} />
      </Container>
    </Wrapper>
  );
}

export default Loading;
